// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"04725818","442":"c6108ce3","483":"1fdbf6d6","657":"04b4c0f9","751":"e449c745","773":"dbe45580"}[chunkId] + ".chunk.js";
};